import React from 'react'
import ReactDOM from 'react-dom'

let overpanelRoot = document.getElementById('overpanel-root')
if (!overpanelRoot) {
  overpanelRoot = document.createElement('div')
  overpanelRoot.id = 'overpanel-root'
  document.body.appendChild(overpanelRoot)
}

export default class Portal extends React.Component<{children: any}> {
  dom = document.createElement('div')

  componentDidMount() {
    overpanelRoot.appendChild(this.dom)
  }

  componentWillUnmount() {
    overpanelRoot.removeChild(this.dom)
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.dom)
  }
}
